import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PdfIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7V1H22V18C22 20.7568 19.7568 23 17 23H2V17H4V21H17C18.6543 21 20 19.6543 20 18V3H4V7H2Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M2 15.435H3.287V12.906H4.448C6.212 12.906 6.806 11.925 6.806 10.917C6.806 9.909 6.203 9.009 4.556 9.009H2V15.435ZM3.287 11.844V10.098H4.385C4.997 10.098 5.537 10.287 5.537 10.944C5.537 11.664 5.006 11.844 4.403 11.844H3.287Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7.992 15.435H10.233C12.159 15.435 13.5 14.121 13.5 12.186C13.5 10.206 12.114 8.99997 10.251 8.99997H7.992V15.435ZM9.279 14.229V10.206H10.017C11.484 10.206 12.213 10.935 12.213 12.186C12.213 13.635 11.412 14.229 10.026 14.229H9.279Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M14.5 15.435H15.787V13.023H18.37V11.853H15.787V10.242H18.775V8.99997H14.5V15.435Z",
    fill: "currentColor"
  }));
}